

export interface PatientAllowedMessageReceiverModel {
  senderPatientID?: number;
  userID?: number;
  loginID?: number;
  userTypeID?: number;
  isTreatmentTeam?: boolean;
  isPrimaryServiceCoordinator?: boolean;
  name?: string;
  photoID?: number;
}
